import React from 'react';
import Reports from '../Sales/Reports';
import { useLocation } from 'react-router-dom';

/**
 * Wrapper component for Sales Review Meeting mode
 * This opens in fullscreen and is used by organizers during meetings
 */
const MeetingReport = () => {
  const location = useLocation();
  return (
    <Reports
      mode="meeting"
      projectID={location.state?.projectID}
      month={location.state?.month}
      priorityId={location.state?.priorityId}
    />
  );
};

export default MeetingReport;
